
export default function RecruitPage() {
  const positions = [
    {
      title: '전략기획',
      description: '구축 & 운영, 서비스모델 기획',
      team: '전략기획실 기획팀',
      status: '00명 충원중',
    },
    {
      title: '전자문서 LAB',
      description: '공공 및 금융기관 전자문서 제작',
      team: 'IT 개발실',
      status: '00명 충원중',
    },
    {
      title: '모바일 LAB',
      description: 'Native, Hybrid, WEB/APP 제작',
      team: 'IT 개발실',
      status: '00명 충원중',
    },
    {
      title: '솔루션 LAB',
      description: '스마트 업무지원 솔루션 기획',
      team: 'R&D팀, 기획팀',
      status: '00명 충원중',
    },
    {
      title: '유지보수 LAB',
      description: 'WEB/APP 유지보수',
      team: 'IT 기술지원팀',
      status: '00명 충원중',
    },
    {
      title: '디자인 LAB',
      description: 'WEB/APP 디자인 업무',
      team: '디자인팀',
      status: '00명 충원중',
    },
  ];

  const techStack = [
    { category: 'AI/ML', items: ['Python', 'TensorFlow', 'PyTorch', 'Scikit-learn'] },
    { category: 'Backend', items: ['Java/Spring', 'Node.js', 'FastAPI', 'PostgreSQL'] },
    { category: 'Frontend', items: ['React', 'TypeScript', 'Next.js', 'TailwindCSS'] },
    { category: 'Data', items: ['Apache Kafka', 'Spark', 'Elasticsearch', 'Redis'] },
    { category: 'DevOps', items: ['AWS', 'Docker', 'Kubernetes', 'Jenkins', 'Terraform'] },
  ];

  const benefits = [
    { 
      icon: 'ri-calendar-check-line', 
      title: '주 5일 근무', 
      desc: '워라벨이 보장되고 자기계발이 원활할 수 있는 주 5일 근무를 원칙으로 합니다.' 
    },
    { 
      icon: 'ri-flight-takeoff-line', 
      title: '해외 워크샵', 
      desc: '직원들의 친목을 도모하고 재충전의 시간을 갖도록 지원합니다.' 
    },
    { 
      icon: 'ri-book-open-line', 
      title: '교육지원', 
      desc: '업무 전문성 강화를 위한 사내·외 교육을 적극 지원합니다.' 
    },
    { 
      icon: 'ri-money-dollar-circle-line', 
      title: '인센티브', 
      desc: '개인별 평가를 통해 연 1~2회 인센티브를 지급합니다.' 
    },
    { 
      icon: 'ri-heart-line', 
      title: '경조사', 
      desc: '경조사 발생 시 경조 휴가 및 경조사 지원 제도를 운영합니다.' 
    },
    { 
      icon: 'ri-sun-line', 
      title: 'REFRESH 휴가', 
      desc: '연차휴가 외 별도의 Refresh 휴가를 성과에 따라 지급합니다.' 
    },
    { 
      icon: 'ri-gamepad-line', 
      title: 'PLAY SHOP', 
      desc: '연 2회 레저 및 문화활동을 지원합니다.' 
    },
    { 
      icon: 'ri-gift-line', 
      title: '기타복지', 
      desc: '명절, 생일, 우수사원 포상 등 다양한 복지제도를 운영합니다.' 
    },
  ];

  const scrollToBottom = () => {
    window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
  };

  return (
    <div className="pt-20">
      <section className="py-36 bg-gradient-to-b from-[#0A1F1F] to-[#0D9488]">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="max-w-4xl">
            <span className="text-sm font-medium text-[#5EEAD4] mb-4 block">채용</span>
            <h1 className="text-5xl md:text-6xl font-bold text-white leading-tight mb-8">
              함께 성장할<br />
              동료를 찾습니다
            </h1>
            <p className="text-lg text-gray-200 leading-relaxed">
              AI·데이터 기반 기술로 실질적인 문제를 해결하는<br />
              4-lab에서 함께 성장할 동료를 기다립니다.
            </p>
          </div>
        </div>
      </section>

      <section className="py-36 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="mb-20">
            <h2 className="text-4xl font-bold text-gray-900 mb-6">
              4-lab에서 일한다는 것
            </h2>
            <p className="text-lg text-gray-600 leading-relaxed max-w-3xl">
              4-lab은 실질적인 문제를 해결하는 것에 집중합니다.
              공공기관과 기업의 디지털 전환을 돕고, 연구개발을 통해 새로운 가치를 창출합니다.
              함께 성장하고 배우며, 의미 있는 일을 하고 싶은 분들을 환영합니다.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 mb-20">
            <div className="bg-[#F0FDFA] rounded-lg p-8 border border-[#99F6E4]/30">
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#14B8A6]/10 mb-4">
                <i className="ri-lightbulb-flash-line text-2xl text-[#0D9488]"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">의미 있는 프로젝트</h3>
              <p className="text-sm text-gray-600">
                공공과 기업의 실질적인 문제를 해결하는 프로젝트에 참여합니다.
              </p>
            </div>

            <div className="bg-[#F0FDFA] rounded-lg p-8 border border-[#99F6E4]/30">
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#14B8A6]/10 mb-4">
                <i className="ri-rocket-line text-2xl text-[#0D9488]"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">기술 성장</h3>
              <p className="text-sm text-gray-600">
                최신 기술을 활용하고 연구개발을 통해 지속적으로 성장합니다.
              </p>
            </div>

            <div className="bg-[#F0FDFA] rounded-lg p-8 border border-[#99F6E4]/30">
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#14B8A6]/10 mb-4">
                <i className="ri-team-line text-2xl text-[#0D9488]"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">협업 문화</h3>
              <p className="text-sm text-gray-600">
                수평적이고 자유로운 분위기에서 함께 문제를 해결합니다.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-36 bg-[#F0FDFA]">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="mb-20">
            <h2 className="text-4xl font-bold text-gray-900 mb-6">기술 스택</h2>
            <p className="text-lg text-gray-600">
              4-lab에서 사용하는 주요 기술들입니다.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {techStack.map((stack, index) => (
              <div
                key={index}
                className="bg-white rounded-lg p-8 border border-[#99F6E4]/30"
              >
                <h3 className="text-lg font-bold text-gray-900 mb-4">{stack.category}</h3>
                <div className="flex flex-wrap gap-2">
                  {stack.items.map((item, itemIndex) => (
                    <span
                      key={itemIndex}
                      className="px-3 py-1 bg-[#F0FDFA] text-sm font-medium text-[#0F766E] rounded-full"
                    >
                      {item}
                    </span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-36 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="mb-20">
            <h2 className="text-4xl font-bold text-gray-900 mb-6">CAREERS</h2>
            <p className="text-lg text-gray-600">
              현재 모집 중인 분야입니다.
            </p>
          </div>

          <div className="space-y-6">
            {positions.map((position, index) => (
              <div
                key={index}
                className="bg-white rounded-lg p-8 border border-gray-200 hover:shadow-lg transition-all duration-300"
              >
                <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-4">
                  <div>
                    <h3 className="text-2xl font-bold text-gray-900 mb-2">
                      {position.title}
                    </h3>
                    <div className="flex flex-wrap gap-3 mb-2">
                      <span className="text-sm text-gray-600">{position.team}</span>
                      <span className="text-sm text-gray-400">·</span>
                      <span className="text-sm text-gray-600">{position.status}</span>
                    </div>
                  </div>
                  <button
                    onClick={scrollToBottom}
                    className="inline-flex items-center justify-center px-6 h-10 bg-[#0D9488] text-white rounded-full font-medium text-sm hover:bg-[#0F766E] transition-colors cursor-pointer whitespace-nowrap mt-4 md:mt-0"
                  >
                    지원하기
                  </button>
                </div>
                <p className="text-sm text-gray-600">{position.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-36 bg-[#F0FDFA]">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="mb-20">
            <h2 className="text-4xl font-bold text-gray-900 mb-6">WELFARE</h2>
            <p className="text-lg text-gray-600">
              4-lab 구성원들을 위한 다양한 복지 제도를 운영합니다.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {benefits.map((benefit, index) => (
              <div
                key={index}
                className="bg-white rounded-lg p-8 border border-[#99F6E4]/30"
              >
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#14B8A6]/10 mb-4">
                  <i className={`${benefit.icon} text-2xl text-[#0D9488]`}></i>
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2">{benefit.title}</h3>
                <p className="text-sm text-gray-600">{benefit.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-36 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="bg-gradient-to-br from-[#0A1F1F] to-[#0D9488] rounded-lg p-16 text-center">
            <h2 className="text-4xl font-bold text-white mb-6">
              지원 방법
            </h2>
            <p className="text-lg text-gray-200 mb-8 max-w-2xl mx-auto">
              관심 있는 포지션에 지원하시거나,<br />
              문의 페이지를 통해 편하게 연락주세요.
            </p>
            <a
              href="https://www.jobkorea.co.kr/company/43456747/Recruit"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center px-10 h-14 bg-white text-[#0D9488] rounded-full font-medium text-base hover:bg-gray-100 transition-colors cursor-pointer whitespace-nowrap"
            >
              입사지원하기
              <i className="ri-arrow-right-line ml-2"></i>
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
